import type { OpsDocBlock } from "../../shared/operations-docs-schemas";

function escapeText(text: string): string {
  return text.replace(/[\\`*_[\]<>#~|.!+=-]/g, "\\$&");
}

function textBlockMarkdown(
  block: Exclude<OpsDocBlock, { type: "markdown" | "divider" | "code" }>,
): string {
  const text = escapeText(block.text).replaceAll("\n", "  \n");
  switch (block.type) {
    case "heading-one":
      return `# ${text}`;
    case "heading-two":
      return `## ${text}`;
    case "bulleted-list":
      return `- ${text.replaceAll("\n", "\n  ")}`;
    case "numbered-list":
      return `1. ${text.replaceAll("\n", "\n   ")}`;
    case "checklist":
      return `- [${block.checked ? "x" : " "}] ${text.replaceAll("\n", "\n  ")}`;
    case "quote":
      return text
        .split("\n")
        .map((line) => `> ${line}`)
        .join("\n");
    case "paragraph":
      return text;
  }
}

/** Legacy text is literal; conversion preserves punctuation, line breaks and block structure. */
export function documentMarkdown(blocks: readonly OpsDocBlock[]): string {
  return blocks
    .map((block) => {
      if (block.type === "markdown") return block.text;
      if (block.type === "divider") return "---";
      if (block.type === "code") {
        const runs = block.text.match(/`+/g) ?? [];
        const fence = "`".repeat(Math.max(3, ...runs.map((run) => run.length + 1)));
        return `${fence}${block.language}\n${block.text}\n${fence}`;
      }
      return textBlockMarkdown(block);
    })
    .join("\n\n");
}

export function markdownBlocks(markdown: string): OpsDocBlock[] {
  return [{ id: "block_document", type: "markdown", text: markdown }];
}

export function safeDocumentLink(value: string): string | null {
  try {
    const url = new URL(value);
    return ["https:", "http:", "mailto:"].includes(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
}
